<div class="tasks">
  <div class="tasks-table__wrapper">
    <table
      class="tasks-table__element"
      aria-label="Tasks"
      mat-table
      [dataSource]="dataSource()"
    >
      <ng-container matColumnDef="task">
        <th
          *matHeaderCellDef
          class="tasks-table__column--task"
          mat-header-cell
        >
          Task
        </th>
        <td
          *matCellDef="let entity"
          mat-cell
        >
          {{ entity.name }}
        </td>
      </ng-container>
      <ng-container matColumnDef="responsibleUsers">
        <th
          *matHeaderCellDef
          class="tasks-table__column--responsibleUsers"
          mat-header-cell
        >
          Responsible
        </th>
        <td
          *matCellDef="let entity"
          mat-cell
        >
          @if (entity.responsibleUsers && entity.responsibleUsers.length) {
            <div class="tasks-table__column__responsible-users">
              @for (user of entity.responsibleUsers; track user) {
                <procure-tag [user]="user">
                  {{ user.name }}
                </procure-tag>
              }
            </div>
          } @else {
            -
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="dueDate">
        <th
          *matHeaderCellDef
          class="tasks-table__column--dueDate"
          mat-header-cell
        >
          Due Date
        </th>
        <td
          *matCellDef="let entity"
          mat-cell
        >
          {{ entity.dueDate | date }}
        </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th
          *matHeaderCellDef
          class="tasks-table__column--status"
          mat-header-cell
        >
          Status
        </th>
        <td
          *matCellDef="let entity"
          mat-cell
        >
          @if (entity.status) {
            <procure-status-badge [status]="entity.status" />
          } @else {
            -
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th
          *matHeaderCellDef
          class="tasks-table__column--actions"
          mat-header-cell
        >
          Actions
        </th>
        <td
          *matCellDef="let entity; let i = index"
          mat-cell
        >
          <button
            procure-button
            variant="ghost"
            color="black"
            matTooltip="Edit task"
            (click)="edit.emit(i)"
          >
            <mat-icon>create</mat-icon>
          </button>
          <button
            procure-button
            variant="ghost"
            color="black"
            matTooltip="Remove task"
            (click)="remove.emit(i)"
          >
            <mat-icon>clear</mat-icon>
          </button>
        </td>
      </ng-container>
      <tr *matNoDataRow>
        <td [attr.colspan]="displayedColumns().length">There are no tasks.</td>
      </tr>
      <tr
        *matHeaderRowDef="displayedColumns()"
        mat-header-row
      ></tr>
      <tr
        *matRowDef="let row; columns: displayedColumns()"
        mat-row
      ></tr>
    </table>
  </div>
</div>
